import type { PlanGateway } from '@/queries/plans/types'
import { defineStore } from 'pinia'

export const usePlansStore = defineStore('user-plans', {
  persist: true,
  state: () => ({
    plans: [] as PlanGateway[]
  }),
  getters: {
    getPlans: (state) => state.plans
  },
  actions: {
    setPlans(payload: PlanGateway[]) {
      this.plans = payload
    }
  }
})
